import type { FecJournalMappingWithImport } from '../types/fecJournalMappingWithImport'
import { getSiblingFecJournalMappings } from './getSiblingFecJournalMappings'

interface GetLockedFecJournalMappingIdsParams {
  /** Every journal mapping of the session, one per import. */
  allMappings: FecJournalMappingWithImport[]
  /** The rows on screen: one per journal, however many imports carry it. */
  displayedMappings: FecJournalMappingWithImport[]
  /** Imports whose journals are confirmed already: the backend takes no more changes on them. */
  lockedFecImportIds: ReadonlySet<string>
}

/**
 * A row stands for the same journal in every import, and an edit goes to all of them. So it is locked as soon as one
 * of those imports is, which also keeps a change from being sent to an import that is confirmed.
 */
export const getLockedFecJournalMappingIds = ({
  allMappings,
  displayedMappings,
  lockedFecImportIds,
}: GetLockedFecJournalMappingIdsParams): Set<string> => {
  const lockedMappingIds = new Set<string>()

  for (const mapping of displayedMappings) {
    const linkedMappings = [mapping, ...getSiblingFecJournalMappings(allMappings, mapping.id, mapping.siblingIds)]

    if (linkedMappings.some(({ fecImportId }) => lockedFecImportIds.has(fecImportId))) {
      lockedMappingIds.add(mapping.id)
    }
  }

  return lockedMappingIds
}
